import { AutoMap } from "@automapper/classes";
import { AppareilDTO } from "./appareil.dto";


export class UserDTO {
    @AutoMap()
    email!: string;
    @AutoMap()
    password!: string;
    @AutoMap()
    phone!: string;
    @AutoMap()
    firstName!: string;
    @AutoMap()
    lastName!: string;
    @AutoMap(() => [AppareilDTO])
    appareilQualifList: AppareilDTO[] = []
}
